(function () {
    'use strict';

    function entityCard() {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/entityCard.html',
            scope: {
                entity: '=',
                cardStyle: '@',
                actions: '=',
                showBadges: '='
            },
            link: function (scope, element, attrs) {
                scope.toggleEntityAccordion = function () {
                    scope.entity.open = !scope.entity.open;
                }

                scope.hasActions = attrs.actions;

                scope.callAction = function(actionName) {
                    scope.actions[actionName].call(scope.entity);
                }

                if ('preventSelection' in attrs) {
                    scope.preventSelection = true;
                }
            }
        };
    }

    entityCard.$inject = [];

    angular.module('ecap.common').directive('entityCard', entityCard);
})();